export default __webpack_public_path__ + "static/media/Collaborate.e66972e2.svg";